// extracted by mini-css-extract-plugin
module.exports = {"content_div":"MainVideo_content_div__1rdo9","iframe_div":"MainVideo_iframe_div__1XVkN"};